import React, { useEffect, useState } from 'react';

import UserAccessThumbnail from '../../assets/images/access-management-thumbnail.png';
import { Typography } from '../../designComponents';
import YoutubeVideoEmbed from '../../designComponents/YoutubeVideoEmbed';
import { escapePlanning, printingService, sectionTitle } from './contents';
import {
  DetailsContainerStyled,
  ServiceMenuContainerStyled,
  ServicesDetailsStyled,
} from './style';

const ServicesDetails = () => {
  const [activeSection, setActiveSection] = useState('symbolsAndTemplates');
  const sectionIds = sectionTitle.map((x) => x.id);

  useEffect(() => {
    const handleScroll = () => {
      for (const sectionId of sectionIds) {
        const ele = document.querySelector(`#${sectionId}`);
        if (ele) {
          const { top, bottom } = ele.getBoundingClientRect();
          if (
            top + 100 <= window.innerHeight / 2 &&
            bottom - 100 >= window.innerHeight / 2
          ) {
            setActiveSection(sectionId);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToSection = (sectionId: string) => {
    setActiveSection(sectionId);
    const section = document.querySelector(`#${sectionId}`);
    section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <ServicesDetailsStyled className="container">
      <ServiceMenuContainerStyled>
        <Typography size={20} style={{ fontWeight: 600, marginBottom: '20px' }}>
          SERVICES
        </Typography>
        {sectionTitle.map((section) => (
          <Typography
            key={section.id}
            className={`menu-item ${activeSection === section.id ? 'active' : ''}`}
            onClick={() => {
              scrollToSection(section.id);
            }}
          >
            {section.label}
          </Typography>
        ))}
      </ServiceMenuContainerStyled>
      <DetailsContainerStyled>
        <div className="section" id="symbolsAndTemplates">
          <Typography className="section-title">
            Global <span className="color-text__primary">Symbols</span> and
            <span className="color-text__primary"> Templates </span>
            Repository
          </Typography>
          <Typography className="section-desc">
            Our extensive library includes a diverse range of symbols, and
            templates meticulously designed to meet the unique needs of our
            clients worldwide.
          </Typography>
          <Typography className="section-desc color-text__sky-blue">
            Who can Upload Symbols and Templates?
          </Typography>
          <Typography className="section-desc ">
            Symbols and templates within Escapeplan can be uploaded exclusively
            by administrators. They have the authority and responsibility to
            curate and manage the repository, ensuring that it remains
            up-to-date and relevant to users' needs. Administrators can add new
            symbols and templates, update existing ones, and organize the
            repository for easy access by technicians.
          </Typography>
          <Typography className="section-desc color-text__sky-blue">
            Who can Access Symbols and Templates?
          </Typography>
          <Typography className="section-desc ">
            Symbols and templates within Escapeplan are accessible to
            technicians. Once uploaded by administrators, technicians have the
            privilege to browse, search, and download these resources according
            to their project needs.
          </Typography>
        </div>
        <div className="section" id="userAccessManagement">
          <Typography className="section-title">
            <span className="color-text__primary">User Access</span> Management
          </Typography>
          <Typography className="section-desc">
            At Escapeplan, we prioritize user access management to ensure
            security and efficiency within our platform. Administrators wield
            the authority to provide or block access to users ( Fire team and
            Draftsmen ), allowing for streamlined control over what are they
            allowed to do.
          </Typography>
          <YoutubeVideoEmbed
            thumbnailImgURL={UserAccessThumbnail}
            videoEmbededKey="41v83rfTkps"
          />
        </div>
        <div className="section" id="tipsForEscapePlanning">
          <Typography className="section-title">
            Tips for&nbsp;
            <span className="color-text__primary">Escape Planning</span>
          </Typography>
          <Typography className="section-desc">
            At EscapePlan, we've simplified the process of building blueprint
            creation. Our intuitive platform offers a seamless experience for
            clients and professionals alike, streamlining everything from
            uploading building drawings to finalizing escape plans. Here are
            some tips on how to get started with us.
          </Typography>
          <div className="list-container">
            {escapePlanning.map((data, index) => (
              <div className="list" key={data.title}>
                <Typography className="numberBullet">{index + 1}</Typography>
                <Typography className="section-desc color-text__sky-blue">
                  {data.title}{' '}
                </Typography>
                <Typography className="list-desc">{data.desc}</Typography>
              </div>
            ))}
          </div>
        </div>
        <div className="section" id="printingService">
          <Typography className="section-title">
            <span className="color-text__primary">Printing </span> service
            Integration
          </Typography>
          <Typography className="section-desc">
            Explore our seamless integration with printers, allowing clients to
            effortlessly assign printing tasks or create jobs for printers.
            Efficiently manage the printing and delivery process, ensuring
            flawless reproduction of drawings and timely delivery to the
            specified shipping address.
          </Typography>
          <div className="list-container">
            {printingService.map((data, index) => (
              <div className="list" key={data.title}>
                <Typography className="numberBullet">{index + 1}</Typography>
                <Typography className="section-desc color-text__sky-blue">
                  {data.title}{' '}
                </Typography>
                <Typography className="list-desc">{data.desc}</Typography>
              </div>
            ))}
          </div>
        </div>
        <div className="section" id="multilingualSupport">
          <Typography className="section-title">
            Multilingual Support
          </Typography>
          <Typography className="section-desc">
            Our platform offers robust multilingual support, empowering admins
            to tailor the language settings to match the specific needs of their
            country. With this feature, admins can effortlessly translate the
            interface, instructions, and communication channels, enhancing
            accessibility and user engagement across different linguistic
            backgrounds. Whether it's English, Spanish, French, or any other
            language, our platform ensures that users feel at home, fostering
            inclusivity and user satisfaction.
          </Typography>
        </div>
      </DetailsContainerStyled>
    </ServicesDetailsStyled>
  );
};

export default ServicesDetails;
